// @flow
import type { Query } from "common/graphql/types"
import gql from "graphql-tag"
import type { EligibleDiscount } from "./types"

export const listDiscounts: Query<EligibleDiscount[]> = {
  gql: gql`
    query listDiscounts($filter: ListDiscountsFilter) {
      discount {
        list(filter: $filter) {
          data {
            id
            percentage
          }
        }
      }
    }
  `,
  selector: ["discount", "list", "data"],
}



// WEBPACK FOOTER //
// ./src/data/discounts/queries.js